import PropTypes from 'prop-types';
import React, { Component } from 'react';
import StickyName from './components/SideBySideStickyNameWidget';

class StickyNames extends Component {
  render() {
    const { barbersViewed } = this.props;

    const barbers = barbersViewed.map((barber) => {
      return (
        <StickyName
          stickyClass={'c-calendar-dayview c-calendar-dayview--notimeaxis c-calendar-combined-name fc fc-unthemed'}
          key={barber.id}
          barber={barber}
        />
      );
    });

    return (
      <div className="c-calendar-dayview-wrapper c-calendar-dayview-wrapper--sticky-names js-calendar-names">
        { barbers }
      </div>
    );
  }
}

StickyNames.propTypes = {
  barbersViewed: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default StickyNames;
